export default __webpack_public_path__ + "static/media/OrderCard.b1bef386.svg";